import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@unicup-ticketing/auth';
import { map, of, switchMap } from 'rxjs';

export const LoginIfNotAuthenticated: CanActivateFn = (
  route,
  state,
  router = inject(Router),
  authService = inject(AuthService),
) => {
  return authService.isAuthenticated().pipe(
    switchMap(authenticated => {
      if (authenticated) {
        return of(true);
      }
      // Go to the identity provider directly instead of via a redirect-only route, so no history entry is left
      // behind that would trap the user when navigating back from Keycloak. On the initial navigation (deep link,
      // reload) the current entry is the guarded page itself, so it is replaced to avoid a sign in loop.
      return authService.triggerAuthentication(state.url, !router.navigated).pipe(map(() => false));
    }),
  );
};
